// Docs metions this value is always hardcoded
// eslint-disable-next-line max-len
// (https://petpartnersinc.visualstudio.com/Figo%20Quote%20and%20Enrollment/_workitems/edit/211281)
const ADVERTISER = 1;

export const sendEverflowQuote = async (groupCode = '') => {
  try {
    const { EF } = window;
    const transactionId = EF?.getAdvertiserTransactionId?.(ADVERTISER);

    // Get the tracking domain since it is injected from GTM
    // eslint-disable-next-line no-underscore-dangle
    const trackingDomain = EF?._trackingDomain;

    await fetch(`${trackingDomain}?nid=1677&aid=1&adv_event_id=1`
      + `&transaction_id=${transactionId}`
      + `&coupon_code=${groupCode}&adv1=${groupCode}`);
    // eslint-disable-next-line no-console
    console.log('[Everflow] - Quote event sent');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('[Everflow] - Error with everflow quote event', error);
  }
};

export const sendEverflowPolicy = async ({
  amount = 0,
  groupCode = '',
  policyId = '',
}) => {
  try {
    const { EF } = window;
    const transactionId = EF?.getAdvertiserTransactionId?.(ADVERTISER);

    // Get the tracking domain since it is injected from GTM
    // eslint-disable-next-line no-underscore-dangle
    const trackingDomain = EF?._trackingDomain;
    await fetch(`${trackingDomain}?nid=1677&aid=1`
      + `&transaction_id=${transactionId}&coupon_code=${groupCode}`
      + `&adv1=${groupCode}&amount=${amount}&order_id=${policyId}`);
    // eslint-disable-next-line no-console
    console.log(`[Everflow] - Policy event sent for ${policyId}`);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(
      `[Everflow] - Error with everflow policy event for ${policyId}`,
      error,
    );
  }
};
